import { render } from "./BienBanKiemNghiemTable.vue?vue&type=template&id=165ed382&ts=true"
import script from "./BienBanKiemNghiemTable.vue?vue&type=script&lang=ts"
export * from "./BienBanKiemNghiemTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__